
function get2DigitFmt(val) {
    return ('0' + val).slice(-2);
}

var pageTrainingClassCalendar = {
    calendarInstance = null,
    selectedDate = null,
    selectedMonth = new Date().getMonth() + 1,
    selectedYear = new Date().getFullYear(),
    timeFilterMode = 'month', // month = time is filtered by month/year, date = time is filtered by date
    $calendar = jQuery('#calendar'),
    $arrowLeft = jQuery('.arrow-left-decoration'),
    $arrowRight = jQuery('.arrow-right-decoration'),
    $displayContainer = jQuery(".sessions-container > div"),
    $sesionsContainer = jQuery(".training-class-sessions-container"),
    $filterContainer = jQuery('.courses-container[data-accordion]'),
    selectedCourses = [],
    courseDates = [],
    openedSmallcourses = [], // which courses are lastly opened on small's courses accordion?

    searchDates: function() {
        pageTrainingClassCalendar.$sesionsContainer.children().each(function() {
            $(this).children().each(function(){
                var sessionDate = $(this).data('date');
                if (!pageTrainingClassCalendar.courseDates.includes(sessionDate)) {
                    pageTrainingClassCalendar.courseDates.push(sessionDate);
                }                  
            })
        })
    },

    checkSelectedCourse: function() {
        var spans = document.getElementsByClassName("js-trigger-filter-calendar");
        for (var i = 0; i < spans.length; i++) {
            if (spans[i].checked == true) {
                $course = spans[i].getAttribute('data-course');
                if (!pageTrainingClassCalendar.selectedCourses.includes($course)) {
                    pageTrainingClassCalendar.selectedCourses.push($course);
                }
            }
        }
    },

    searchSession: function() {
        var self = this;
        this.$displayContainer.empty();
        var $selecteds = [];
        var courseDates = [];

        if (pageTrainingClassCalendar.timeFilterMode == 'month') {
            pageTrainingClassCalendar.selectedDate = null;
        }

        this.$sesionsContainer.children().each(function() {
            var $session = $(this);
            var isCourseSelected;

            if (self.selectedCourses.length > 0) {
                var sessionCourse = $session.data('course');
                isCourseSelected = false;
                for (var i = 0; i < self.selectedCourses.length; i++) {
                    if (self.selectedCourses[i] == sessionCourse) {
                        isCourseSelected = true;
                        break;
                    }
                }
            } else {
                isCourseSelected = true;
            }

            if (isCourseSelected) {
                $session.children().each(function(){
                    var $item = $(this);
                    var sessionDate = $item.data('date');
                    // filter by date
                    if (self.selectedDate) {
                        if ((self.selectedDate == sessionDate)) {
                            $selecteds.push($item);   
                        };    
                    // filter by month-year
                    } else {
                        // date format: YYYY-MM-DD
                        var splitDate = sessionDate.split('-');
                        if ((get2DigitFmt(self.selectedMonth) == splitDate[1]) && (self.selectedYear == splitDate[0])) {
                            $selecteds.push($item);    
                            courseDates.push(sessionDate); 
                        };
                    }
                })
            }       
        });

        // group sessions by training class
        var grouped = {};
        $.each($selecteds, function() {
            var $session = $(this);
            var className = $session.data('class-name');
            if (typeof grouped[className] == 'undefined') {
                grouped[className] = [];
            }
            grouped[className].push($session);
        });

        // add each class and its sessions
        if (!$.isEmptyObject(grouped)) {
            if (Foundation.MediaQuery.current == 'small') {
                var $wrapper = $('<div class="cell"></div>').appendTo(self.$displayContainer);
                var $accordion = $('<div class="small-accordion" data-accordion data-allow-all-closed="true" data-multi-expand="true" data-slide-speed="0"></div>').appendTo($wrapper);
                $.each(grouped, function(className, sessions) {
                    var $accordionItem = $(
                        '<div class="accordion-item '+($.inArray(className, pageTrainingClassCalendar.openedSmallcourses) >= 0 ? 'is-active' : '')+'" data-accordion-item data-course="'+className+'">'+
                            '<a href="javascript:void(0)" class="title"><h3>'+className+'</h3></a>'+
                        '</div>'
                    ).appendTo($accordion);
                    var $accordionContent = $('<div class="accordion-content" data-tab-content></div>').appendTo($accordionItem);
                    $.each(sessions, function() {
                        $(this).clone().appendTo($accordionContent);
                    });
                });
                new Foundation.Accordion($accordion);
                // save opened training class
                $accordion.on('down.zf.accordion up.zf.accordion', function() {
                    //pageTrainingClassCalendar.openedSmallcourses = [];
                    $.each($(this).get(0).childNodes, function() {
                        var courseName = $(this).data('course');
                        if ($(this).is('.is-active')) {
                            if (pageTrainingClassCalendar.openedSmallcourses.indexOf(courseName) < 0) {
                                pageTrainingClassCalendar.openedSmallcourses.push(courseName);
                            }
                        } else {
                            pageTrainingClassCalendar.openedSmallcourses = pageTrainingClassCalendar.openedSmallcourses.filter(value => value != courseName);
                        }
                    });
                    console.log(pageTrainingClassCalendar.openedSmallcourses);
                });
            } else {
                $.each(grouped, function(className, sessions) {
                    $('<div class="cell title"><h3>'+className+'</h3></div>').appendTo(self.$displayContainer);
                    $.each(sessions, function() {
                        $(this).clone().appendTo(self.$displayContainer);
                    });
                });    
            }
        } else {
            $('<div><h3>Session unavailable</h3><p>No session available for course or month/date you selected.</p></div>').appendTo(self.$displayContainer);
        }

        // scroll to sessions section on small
        // if (Foundation.MediaQuery.current == 'small') {
        //     $('html,body').animate({scrollTop: this.$displayContainer.offset().top - 100}, 'slow');
        // }

        // redraw calendar using newly selected course dates
        if (courseDates.length > 0) {
            pageTrainingClassCalendar.courseDates = courseDates;
        } else {
            if (pageTrainingClassCalendar.timeFilterMode == 'month') {
                pageTrainingClassCalendar.courseDates = [];
            }
        }
        pageTrainingClassCalendar.calendarInstance.redraw();
        // reset date selection (visually)
        // strangely this cannot be done via flatpickr
        if (pageTrainingClassCalendar.timeFilterMode == 'month') {
            $('.flatpickr-calendar').find('.flatpickr-day').removeClass('selected');
        }
    }
    
};

(function($) {

    function getMonthString() {
        var date = new Date(pageTrainingClassCalendar.calendarInstance.currentYear, pageTrainingClassCalendar.calendarInstance.currentMonth);
        month = date.toLocaleString('default', { month: 'long' });
        $("#text-month-year").html(month + ' ' + date.getFullYear());
    }

    if (pageTrainingClassCalendar.$calendar.length > 0) {
        pageTrainingClassCalendar.calendarInstance = flatpickr(pageTrainingClassCalendar.$calendar, { 
            inline: true,
            dateFormat: "Y-m-d",
            "locale": {
                "firstDayOfWeek": 1 // start week on Monday
            },
            onChange: function(selectedDates, dateStr, instance) {
                if (pageTrainingClassCalendar.selectedDate == dateStr) {
                    pageTrainingClassCalendar.selectedDate = null;
                    pageTrainingClassCalendar.timeFilterMode = 'month';
                } else {
                    pageTrainingClassCalendar.selectedDate = dateStr;
                    pageTrainingClassCalendar.timeFilterMode = 'date';    
                }
                pageTrainingClassCalendar.searchSession();
            },
            onMonthChange: function(selectedDates, dateStr, instance) {
                pageTrainingClassCalendar.timeFilterMode = 'month';
                pageTrainingClassCalendar.selectedMonth = instance.currentMonth + 1;
                pageTrainingClassCalendar.selectedYear = instance.currentYear;
                pageTrainingClassCalendar.searchSession();
            },
            onDayCreate: function(dObj, dStr, fp, dayElem) {
                var date = dayElem.dateObj;
                key = date.getFullYear() +'-'+ get2DigitFmt(date.getMonth() + 1) +'-'+ get2DigitFmt(date.getDate());
                            
                if (pageTrainingClassCalendar.courseDates.includes(key)) {
                    dayElem.className += ' event-available';
                }
            }
        });

        pageTrainingClassCalendar.$arrowLeft.on('click', function (e) {
            pageTrainingClassCalendar.calendarInstance.changeMonth(-1); 
            getMonthString();
        });

        pageTrainingClassCalendar.$arrowRight.on('click', function (e) {
            pageTrainingClassCalendar.calendarInstance.changeMonth(1); 
            getMonthString();
        });

        $(".js-trigger-filter-calendar").on('click', function() {
            pageTrainingClassCalendar.checkSelectedCourse();
            var course = $(this).data('course');
            $display_filter = $('[data-course-display=' + course + ']');
            
            if (!this.checked) {
                pageTrainingClassCalendar.selectedCourses.splice(pageTrainingClassCalendar.selectedCourses.indexOf(course), 1);
                $display_filter.addClass('hide');
            } else {
                if (!pageTrainingClassCalendar.selectedCourses.includes(course)) {
                    pageTrainingClassCalendar.selectedCourses.push(course);
                }
                $display_filter.removeClass('hide');
            }
            //$(".floating-filter").addClass('hide');
            //$(".accordion-title-text-medium-close").removeClass('hide');
            //$(".training-courses-selected-item").removeClass('hide');
            pageTrainingClassCalendar.timeFilterMode = 'month';
            pageTrainingClassCalendar.searchSession();
        });

        $(".close-training-course").on('click', function() {
            pageTrainingClassCalendar.checkSelectedCourse();
            var course = $(this).data('course-hide');
            $('[data-course=' + course + ']').prop("checked", false);
            $('[data-course-display=' + course + ']').addClass('hide');
            pageTrainingClassCalendar.selectedCourses.splice(pageTrainingClassCalendar.selectedCourses.indexOf(course), 1);
            pageTrainingClassCalendar.timeFilterMode = 'month';
            pageTrainingClassCalendar.searchSession();
        });

        $(".accordion-title-text-medium-close").on('click', function(){
            $(".floating-filter").removeClass('hide');
            $(".accordion-title-text-medium-close").addClass('hide');
            $(".training-courses-selected-item").addClass('hide');
        })

        $(".accordion-title-text-medium-open").on('click', function(){
            $(".floating-filter").addClass('hide');
            $(".accordion-title-text-medium-close").removeClass('hide');
            $(".training-courses-selected-item").removeClass('hide');
        })
        
        $(window).on("load", function() {
            //pageTrainingClassCalendar.searchDates();       
            pageTrainingClassCalendar.checkSelectedCourse();
            pageTrainingClassCalendar.searchSession();
            
            pageTrainingClassCalendar.calendarInstance.redraw();
            getMonthString();        
        });           
    }
})(jQuery);